import React from "react";
import SectionOne from "../Components/Features/sectionOne";
import SectionTwo from "../Components/Features/SectionTwo";
import SectionFour from "../Components/Features/SectionFour";

function Features(props) {
  return (
    <main>
      <section>
        <SectionOne />
      </section>
      <section>
        <SectionTwo />
      </section>
      <section>
        <SectionFour />
      </section>
    </main>
  );
}

export default Features;
